import React, { useEffect, useState, useRef } from 'react';
import { SOURCE_WELCOME_CONFIG } from '../config/sourceWelcome';
import './SourceWelcome.css';

const AVATAR_URL = 'https://avatars.githubusercontent.com/u/94018014?v=4';

const PointingHand = ({ size = 14, pointsDown = true }) => (
  <span
    className={`source-welcome-hand ${pointsDown ? 'source-welcome-hand--down' : 'source-welcome-hand--up'}`}
    style={{ fontSize: size }}
    aria-hidden
  >
    👉
  </span>
);

export default function SourceWelcome() {
  const [config, setConfig] = useState(null);
  const [dismissed, setDismissed] = useState(false);
  const [isExiting, setIsExiting] = useState(false);
  const [targetRect, setTargetRect] = useState(null);

  const source = new URLSearchParams(window.location.search)
    .get('source')
    ?.toLowerCase();

  useEffect(() => {
    if (source && SOURCE_WELCOME_CONFIG[source]) {
      setConfig(SOURCE_WELCOME_CONFIG[source]);
    } else {
      setConfig(null);
    }
  }, [source]);

  useEffect(() => {
    if (!config?.highlightTarget) return;

    const updatePosition = () => {
      const el = document.querySelector(config.highlightTarget);
      if (el) setTargetRect(el.getBoundingClientRect());
    };

    updatePosition();
    window.addEventListener('resize', updatePosition);
    window.addEventListener('scroll', updatePosition, true);
    return () => {
      window.removeEventListener('resize', updatePosition);
      window.removeEventListener('scroll', updatePosition, true);
    };
  }, [config?.highlightTarget]);

  useEffect(() => {
    if (!config?.highlightTarget || dismissed) return;
    const el = document.querySelector(config.highlightTarget);
    if (el) {
      el.classList.add('source-welcome-highlight');
      el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    return () => {
      const target = document.querySelector(config.highlightTarget);
      if (target) target.classList.remove('source-welcome-highlight');
    };
  }, [config?.highlightTarget, dismissed]);

  const handleDismiss = () => {
    setIsExiting(true);
    const target = config?.highlightTarget && document.querySelector(config.highlightTarget);
    if (target) target.classList.remove('source-welcome-highlight');
    setTimeout(() => setDismissed(true), 350);
  };

  if (!config || dismissed) return null;

  return (
    <div
      className={`source-welcome-overlay ${isExiting ? 'source-welcome-exit' : ''}`}
      role="dialog"
      aria-label="Welcome message"
    >
      <div className="source-welcome-backdrop" onClick={handleDismiss} />

      <div className="source-welcome-content">
        <div className="source-welcome-chat">
          <img
            src={AVATAR_URL}
            alt=""
            className="source-welcome-avatar"
            aria-hidden
          />
          <div className="source-welcome-bubble">
            <p className="source-welcome-message">{config.message}</p>
            <button
              className="source-welcome-dismiss"
              onClick={handleDismiss}
              aria-label="Dismiss"
            >
              got it
            </button>
          </div>
        </div>

        {config.highlightTarget && targetRect && (
          <div
            className="source-welcome-pointer"
            style={{
              left: targetRect.left + targetRect.width / 2 - 10,
              top:
                config.pointerPosition === 'below'
                  ? targetRect.bottom + 12
                  : targetRect.top - 56,
            }}
            aria-hidden
          >
            <PointingHand
              size={20}
              pointsDown={config.pointerPosition !== 'below'}
            />
          </div>
        )}
      </div>
    </div>
  );
}
